/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Tag_AcademicInputs */

const en_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academic`)
};

const ar_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكاديمي`)
};

const bn_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একাডেমিক`)
};

const de_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akademiker`)
};

const es_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Académico`)
};

const fr_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Académique`)
};

const pt_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acadêmico`)
};

const zh_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学术`)
};

const tr_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akademik`)
};

const ru_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Академический`)
};

const pl_resume_tag_academic = /** @type {(inputs: Resume_Tag_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akademicki`)
};

/**
* | output |
* | --- |
* | "Academic" |
*
* @param {Resume_Tag_AcademicInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_tag_academic = /** @type {((inputs?: Resume_Tag_AcademicInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Tag_AcademicInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_tag_academic(inputs)
	if (locale === "bn") return bn_resume_tag_academic(inputs)
	if (locale === "de") return de_resume_tag_academic(inputs)
	if (locale === "es") return es_resume_tag_academic(inputs)
	if (locale === "fr") return fr_resume_tag_academic(inputs)
	if (locale === "pt") return pt_resume_tag_academic(inputs)
	if (locale === "zh") return zh_resume_tag_academic(inputs)
	if (locale === "tr") return tr_resume_tag_academic(inputs)
	if (locale === "ru") return ru_resume_tag_academic(inputs)
	if (locale === "pl") return pl_resume_tag_academic(inputs)
	return en_resume_tag_academic(inputs)
});